import 'owl.carousel';

const sliders = document.querySelectorAll('.bm-slider-wrapper');

(function($){

	sliders.forEach(slider => {
		const $slider = $(slider);
		const $carousel = $slider.find('.owl-carousel');

		if ( $carousel.find('> div').length > 1 ) {
			$carousel.owlCarousel({
				loop: true,
				margin: 10,
				nav: true,
				pagination: true,
				items: 1,
				autoplay: true,
				autoplayTimeout: 5000,
				autoplayHoverPause: true,
				autoHeight: true,
				navText: [
					'&nbsp;',
					'&nbsp;',
				],
			});
		} else {
			$carousel.show();
		}
	});

})(jQuery);
